export const DROMO_DATE_FORMAT = [
  "date",
  {
    locale: "en-US",
    outputFormat: "MM-dd-yyyy", // This is the format that will be sent to the backend
    displayFormat: "M/d/yyyy", // This is the format that will be displayed to the user. Also, dates from the input file must match this format.
  },
];
